module.exports = __webpack_public_path__ + "fonts/RobotoSlab_Regular.4855f0cb.ttf";